//this is the list of all the data that can be returned from the admin-center endpoint
// will grow
import type { AdminCenterDataResponse } from '@routes/sidebar/___shared___/api/adminCenterData.api.ts';

export const ADMIN_CENTER_DATA = {
    // stable data
    FLAGS: 'FlagResponse',
    PROFICIENCY_LEVELS: 'ProficiencyLevelResponse',
    RANK_SHORT_CODES: 'RankShortCodeResponse',
    FUEL_TYPE_CATEGORIES: 'FuelTypeCategory',
    FUEL_TYPES: 'FuelType',
    VESSEL_SUB_TYPES: 'VesselSubTypeResponse',
    COUNTRY: 'CountryResponse',

    // dynamic data
    CREW_USERS: 'CrewUserResponse',
    SHORE_USERS: 'ShoreUserResponse',
    RANK_SETS: 'RankSetResponse',
    VESSELS: 'Vessel',
    // notice: this action will also return rankSetResponse + rankSetWithReference data
    RANK_SETS_WITH_REFERENCE: 'RankSetWithReference',
    SHORE_DEPARTMENTS: 'ShoreDepartmentResponse',
    SHORE_DEPARTMENT_TYPES: 'ShoreDepartmentTypeResponse',
    SHORE_TEAMS: 'ShoreTeamResponse',
    SHORE_USER_TITLES: 'ShoreUserTitleResponse',
    TRADING_AREAS: 'TradingAreaResponse',
    VESSEL_DEPARTMENTS: 'VesselDepartmentResponse',
    VESSEL_EQUIPMENT_TYPES: 'VesselEquipmentType',
    VESSEL_GROUPS: 'VesselGroup',
    CLIENT_TENANTS_LIST: 'ClientListItemResponse',
    ENTITY_LOCATION: 'ClientTenantEntityLocationResponse',
    VESSEL_EQUIPMENT_DETAILS: 'VesselEquipmentDetails',
} as const;

export const EMPTY_ADMIN_CENTER_DATA: AdminCenterDataResponse = {
    vesselSubTypeResponse: null,
    vesselGroup: null,
    vesselEquipmentType: null,
    vesselDepartmentResponse: null,
    vessel: null,
    shoreTeamResponse: null,
    shoreDepartmentTypeResponse: null,
    shoreDepartmentResponse: null,
    flagResponse: null,
    crewUserResponse: null,
    fuelTypeCategory: null,
    fuelType: null,
    proficiencyLevelResponse: null,
    rankShortCodeResponse: null,
    rankSetResponse: null,
    rankSetWithReference: null,
    shoreUserResponse: null,
    shoreUserTitleResponse: null,
    tradingAreaResponse: null,
    clientListItemResponse: null,
    clientTenantEntityLocationResponse: null,
    countryResponse: null,
    vesselEquipmentDetails: null,
};
